import { readAdsConsent } from "../ads/consent";
import { postAnalytics } from "./postAnalytics";
import { clearAnalyticsSession, ensureAnalyticsSession } from "./sessionCookie";

const api = import.meta.env.VITE_API_URL;

let previousPath: string | null = null;

export const resetSessionNavigation = (): void => {
  previousPath = null;
  clearAnalyticsSession();
};

export const initSessionNavigation = (): void => {
  if (readAdsConsent() !== "accepted") return;
  ensureAnalyticsSession();
};

export const trackSessionNavigation = (path: string): void => {
  try {
    if (readAdsConsent() !== "accepted") return;
    if (!api) return;

    const sessionId = ensureAnalyticsSession();
    if (!sessionId) return;

    const fromPath = previousPath && previousPath !== path ? previousPath : undefined;
    previousPath = path;

    const url = `${api}/analytics/session`;
    const body = JSON.stringify({
      sessionId,
      path,
      fromPath,
    });

    const send = () => {
      postAnalytics(url, body);
    };

    const ric = (
      window as Window & {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      }
    ).requestIdleCallback;

    if (typeof ric === "function") {
      ric(send, { timeout: 2500 });
    } else {
      window.setTimeout(send, 0);
    }
  } catch {
    // Ignore analytics failures completely.
  }
};
